<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">

        <layout-header />

        <!-- Page Content -->
        <div class="content">
            <div class="container">

                <div class="row">
                    <div class="col-lg-7 col-md-8 order-md-1 order-2">
                        <div class="card">
                            <div class="card-body">
                                <!-- Checkout Form -->
                                <div v-show="isLoggedIn">
                                    <!-- Personal Information -->
                                    <div class="info-widget">
                                        <h4 class="card-title">Information Personnelles</h4>
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="form-group card-label">
                                                    <label>Nom Complet</label>
                                                    <input class="form-control" type="text"
                                                        v-model="currentUser.full_name" :disabled="true">
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group card-label">
                                                    <label>E-mail</label>
                                                    <input class="form-control" type="email" v-model="currentUser.email"
                                                        :disabled="true">
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group card-label">
                                                    <label>N° Téléphone</label>
                                                    <input class="form-control" type="text"
                                                        v-model="currentUser.phone_number" :disabled="true">
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group card-label">
                                                    <label>N° Whatsapp</label>
                                                    <input class="form-control" type="text" :disabled="true"
                                                        v-model="currentUser.whatsapp_number">
                                                </div>
                                            </div>
                                            <div class="col-sm-6" v-if="!user.delegation">
                                                <div class="form-group card-label">
                                                    <label>Délégation</label>
                                                    <v-select :options="delegations" v-model="user.delegation" label="option"
                                                        :reduce="option => option" class="custom-vs form-control input">
                                                        <template #option="{ option }">
                                                            <span><b>{{ option.split(', ')[0] }}</b>, {{ option.split(', ')[1] }}</span>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /Personal Information -->

                                    <div class="row">
                                        <div class="col-md-5 col-sm-12">
                                            <div class="payment-widget">
                                                <h4 class="card-title">Moyens du Paiement</h4>

                                                <div v-if="!booking">
                                                    <div class="alert alert-danger" role="alert">
                                                        {{ errorMessage }}
                                                    </div>
                                                </div>

                                                <div class="pb-2"
                                                    v-if="booking && booking.slot.facility.establishment.payment_methods === 0">
                                                    Aucun moyen de paiement fourni
                                                </div>

                                                <!-- Refund Voucher Payment -->
                                                <div class="payment-list mb-3 "
                                                    v-if="booking && booking.slot.facility.establishment.payment_methods >= 2 && this.refundVouchers.length > 0">
                                                    <label class="payment-radio d-inline mb-0">
                                                        <input type="radio" name="radio" v-model="paymentMethod"
                                                            value="refund voucher" @change="updateFees()">
                                                        <span class="checkmark"></span>
                                                        Bon <span class="text-lowercase">d'</span>achat
                                                    </label>
                                                    <div class="form-inline pl-3 ml-3"
                                                        v-if="this.paymentMethod == 'refund voucher'">
                                                        <select class="custom-select custom-select-sm text-xs"
                                                            v-model="refundVoucherCode" @change="updateFees()">
                                                            <option v-for="voucher in refundVouchers" :key="voucher.id"
                                                                :value="voucher.voucher_code">{{ voucher.voucher_code }}
                                                                ( {{ voucher.amount }}DT )</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <!-- Credit Card Payment -->
                                                <div class="payment-list mb-3"
                                                    v-if="booking && booking.slot.facility.establishment.payment_methods >= 2">
                                                    <label class="payment-radio d-inline mb-0">
                                                        <input type="radio" name="radio" v-model="paymentMethod"
                                                            value="online"> <!-- @change="updateOnlineFees()" -->
                                                        <span class="checkmark"></span>
                                                        Konnect
                                                    </label>
                                                    <div class="form-inline pl-3 ml-3"
                                                        v-if="this.paymentMethod == 'online'">
                                                        <label class="mr-2">Je vais payer </label>
                                                        <select class="custom-select custom-select-sm"
                                                            v-model="partsToPay" @change="updateFees()"><!-- @change="updateOnlineFees() -->
                                                            <option value="full">Tous le montant</option>
                                                            <option value="prepay" v-show="subTotal > defaultDepositPayment">Une avance</option>
                                                        </select>
                                                        <!-- <label class="ml-2">amount</label> -->
                                                    </div>
                                                </div>
                                                <!-- /Credit Card Payment -->

                                                <!-- Paypal Payment -->
                                                <div class="payment-list"
                                                    v-if="booking && (booking.slot.facility.establishment.payment_methods == 1 || booking.slot.facility.establishment.payment_methods == 3)">
                                                    <label class="payment-radio d-inline">
                                                        <input type="radio" name="radio" v-model="paymentMethod"
                                                            value="cash" @change="updateFees()">
                                                        <span class="checkmark"></span>
                                                        Espéces
                                                    </label>
                                                </div>
                                                <!-- /Paypal Payment -->
                                            </div>
                                        </div>
                                        <div class="col-md-7 col-sm-12">
                                            <div class="booking-summary">
                                                <div class="form-row voucher-form"
                                                    v-show="!errorMessage && ['online', 'cash'].includes(paymentMethod)">
                                                    <div class="form-group card-label col-8">
                                                        <label>Bon de réduction/achat</label>
                                                        <input class="form-control text-sm"
                                                            style="height: 36px;min-height: auto;" type="text"
                                                            v-model="couponCode"
                                                            :disabled="booking && booking.slot.sale_price">
                                                    </div>
                                                    <div class="form-group col-4 mt-2">
                                                        <button type="submit"
                                                            class="btn btn-primary w-100 text-xs mt-2 coupon-btn"
                                                            @click="applyCoupon()"
                                                            :disabled="booking && booking.slot.sale_price">
                                                            <span
                                                                class="spinner-border spinner-border-xs text-white m-1 d-none"
                                                                role="status" aria-hidden="true"></span>
                                                            <label class="mb-0 pt-1">Appliquer</label>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="booking-item-wrap">
                                                    <ul class="booking-fee">
                                                        <li class="mb-1"> Frais de réservation <span class="text-xs">{{ bookingFee.toFixed(3) }}<sup>DT</sup></span></li>
                                                        <li class="mb-1"
                                                            v-show="discountVoucherCode != '' && paymentMethod == 'online'">
                                                            Bon de réduction / Code
                                                            <b class="text-xs">({{ discountVoucherCode }})</b>
                                                            <i class="fas fa-times text-danger ml-1"
                                                                @click="removeCoupon()"></i>
                                                            <span class="text-xs" v-show="couponFee > 0">-{{
                                                                couponFee.toFixed(3) }}<sup>DT</sup></span>
                                                        </li>
                                                        <li class="mb-1" v-if="couponFee > 0">
                                                            <b>Réduction</b> <span class="text-xs">{{
                                                                couponFee.toFixed(3) }}<sup>DT</sup></span>
                                                        </li>
                                                        <li>
                                                            <hr>
                                                        </li>
                                                        <li class="mb-1">
                                                            <b>Sous-Total</b> <span class="text-xs">{{
                                                                subTotal.toFixed(3) }}<sup>DT</sup></span>
                                                        </li>
                                                        <li class="mb-1">
                                                            <b>Montant à payer</b> <span class="text-xs">{{
                                                                amountToPay.toFixed(3) }}<sup>DT</sup></span>
                                                        </li>
                                                        <li class="mb-1" v-show="transactionFee > 0">
                                                            Frais de transaction <span class="text-xs">{{
                                                                transactionFee.toFixed(3) }}<sup>DT</sup></span>
                                                        </li>
                                                    </ul>
                                                    <div class="booking-total">
                                                        <ul class="booking-total-list">
                                                            <!-- <li>
                                                                <span>Total à payer</span>
                                                                <span class="total-cost">{{ totalToPay.toFixed(3)
                                                                    }}<sup>DT</sup></span>
                                                            </li> -->
                                                            <li>
                                                                <span>Reste à payer</span>
                                                                <span class="total-cost">{{ remainingToPay.toFixed(3)
                                                                    }}<sup>DT</sup></span>
                                                            </li>
                                                            <li v-show="remainingToRefund > 0">
                                                                <span>À encaisser (Bon d'achat)</span>
                                                                <span class="total-cost">{{ remainingToRefund.toFixed(3)
                                                                    }}<sup>DT</sup></span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <!-- Terms Accept -->
                                                    <div class="terms-accept mt-3">
                                                        <div class="custom-checkbox">
                                                            <label for="terms_accept" class="text-xs ml-1">
                                                                <input type="checkbox" id="terms_accept"
                                                                    v-model="acceptedTerms" :disabled="!isLoggedIn || errorMessage">
                                                                J'ai lu et j'accepte les <a href="/cgu"
                                                                    target="_blank">Conditions Générales
                                                                    d'Utilisation</a> et la <a
                                                                    href="/cancellation-policy"
                                                                    target="_blank">Politique d'Annulation</a>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <!-- /Terms Accept -->

                                                    <!-- Submit Section -->
                                                    <div class="submit-section mt-2">
                                                        <form @submit.prevent="confirmAndPay()">
                                                            <button type="submit" class="btn btn-primary btn-rounded px-4"
                                                                :disabled="!acceptedTerms || !paymentMethod">
                                                                <span class="spinner-border spinner-border-sm text-white m-1 d-none"
                                                                    role="status" aria-hidden="true"></span>
                                                                <label class="m-0 mx-1">Confirmer</label>
                                                            </button>
                                                        </form>
                                                    </div>
                                                    <!-- /Submit Section -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /Checkout Form -->

                            </div>
                        </div>

                    </div>

                    <div class="col-lg-5 col-md-4 order-md-2 order-1 theiaStickySidebar">
                        <div class="stickyside" style="top: 120px;">
                            <!-- Booking Summary -->
                            <div class="card booking-card">
                                <div class="card-header">
                                    <h4 class="card-title">Détails Réservation</h4>
                                </div>
                                <div class="card-body">
                                    <div v-if="booking != null">
                                        <!-- Booking Doctor Info -->
                                        <div class="booking-doc-info">
                                            <router-link :to="'/facilitys/' + booking.slot.facility.id"
                                                class="booking-doc-img">
                                                <img :src="establishment.logo_url || defaultLogo"
                                                    alt="Company Logo">
                                            </router-link>
                                            <div class="booking-info mb-2">
                                                <h4>Terrain {{ facility.name }}</h4>
                                                <h5 class="text-muted"><b>{{ establishment.business_name }}</b></h5>
                                                <div class="shop-details">
                                                    <p class="doc-location">
                                                        <i class="fas fa-map-marker-alt mr-1"></i>
                                                        {{ establishment.address }}, {{ establishment.delegation }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Booking Doctor Info -->

                                        <div class="booking-summary">
                                            <div class="booking-item-wrap">
                                                <ul class="booking-date">
                                                    <li style="margin-bottom: 4px;">
                                                        Date <span>{{ formatDate(booking.start_time) }}</span>
                                                    </li>
                                                    <li style="margin-bottom: 4px;">
                                                        Créneau
                                                        <span>
                                                            {{ formatDate(booking.start_time, 'HH:mm') }} -
                                                            {{ formatDate(booking.end_time, 'HH:mm') }}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="mt-3" v-if="acceptedChallenge">
                                            <div class="custom-checkbox">
                                                <label for="terms_accept" class="text-sm">
                                                    <input type="checkbox" id="terms_accept" v-model="linkToAcceptedChallenge">
                                                    <span class="ml-2">Lier cette réservation au défi ci-dessous:</span>
                                                </label>
                                            </div>
                                            <div class="text-sm">
                                                <span>
                                                    {{ acceptedChallenge.team_a?.name }} <b>VS</b> {{ acceptedChallenge.team_b?.name }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="mt-3 p-3 border rounded bg-light">
                                            <div class="custom-checkbox mb-2">
                                                <label for="open_to_challenges" class="text-sm mb-0">
                                                    <input type="checkbox" id="open_to_challenges" v-model="openToChallenges">
                                                    <span class="ml-2"><b>Ouvert à accepter des défis</b></span>
                                                </label>
                                            </div>
                                            <p class="text-xs text-muted mb-2">Après confirmation de la réservation, les autres équipes pourront vous envoyer un défi.</p>
                                            <div v-if="openToChallenges && challengeTeams.length" class="mt-2">
                                                <label class="text-xs text-muted mb-1">Choisissez l'équipe qui gère ces défis</label>
                                                <select v-model="challengeTeamId" class="form-control form-control-sm custom-select">
                                                    <option :value="null">Sélectionner une équipe...</option>
                                                    <option v-for="team in challengeTeams" :key="team.id" :value="team.id">{{ team.name }}</option>
                                                </select>
                                            </div>
                                            <div v-else-if="openToChallenges && !challengeTeams.length" class="text-xs text-danger">
                                                Vous devez être propriétaire ou capitaine d'une équipe pour activer ce mode.
                                            </div>
                                        </div>

                                    </div>
                                    <div v-else>
                                        <div class="alert alert-danger" role="alert">
                                            {{ errorMessage }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /Booking Summary -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->

    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from 'moment'
import { api } from '@/store';
import defaultLogoPath from '@/assets/img/photo.png'
import voucherManager from "@/utils/voucher";

export default {
    components: {
        vSelect
    },
    props: ['id'],
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        currentUser() {
            return this.$store.getters.currentUser;
        },
        totalFee: function () {
            if (this.booking) {
                return (parseFloat(this.totalToPay) + this.transactionFee).toFixed(3)
            }
            return parseFloat(this.totalToPay).toFixed(3)
        },
        priceCalculate: function () {
            this.totalToPay = this.booking ? this.booking.amount : 0;
            if (this.partsToPay === "prepay") {
                this.totalToPay = this.booking.slot.facility.establishment.fee;
            }
            const amountTot = this.totalToPay;
            const total = (parseFloat(amountTot) + this.transactionFee).toFixed(3);
            return total;
        }
    },
    data() {
        return {
            delegations: [],
            defaultLogo: defaultLogoPath,
            booking: null,
            prebooking: null,
            establishment: null,
            facility: null,
            defaultDepositPayment: 20,
            bookingFee: 0,
            subTotal: 0,
            total: 0,
            amountToPay: 0,
            totalToPay: 0,
            remainingToPay: 0,
            remainingToRefund: 0,
            transactionFee: 0,
            couponFee: 0,
            couponCode: '',
            discountVoucherCode: '',
            refundVoucher: {},
            refundVoucherFee: 0,
            refundVoucherCode: '',
            paymentMethod: null,
            acceptedTerms: false,
            maxParts: 12,
            partsToPay: "",
            url: '',
            errorMessage: null,
            error: '',
            refundVouchers: {},
            acceptedChallenge: {},
            linkToAcceptedChallenge: false,
            user: {},
            challengeTeams: [],
            challengeTeamId: null,
            openToChallenges: false,
        }
    },
    mounted() {
        this.getBooking()
        this.getDelegations()
        this.getChallengeTeams()
        this.user = {...this.currentUser}
    },
    methods: {
        getDelegations() {
            api.get('/core/static/regions/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        async getBooking() {
            return await api.get('/prebooking/' + this.id)
                .then(response => {
                    this.booking = response.data
                    this.prebooking = response.data
                    this.facility = this.booking.slot.facility
                    this.establishment = this.facility.establishment
                    if (this.establishment.payment_methods > 0) {
                        if (this.establishment.payment_methods == 2) {
                            this.paymentMethod = 'online'
                        } else {
                            this.paymentMethod = 'cash'
                        }
                        this.updateFees()
                    }
                    this.getAcceptedChallenge()
                    //this.getRefundVouchers()
                })
                .catch(error => {
                    this.errorMessage = error.response.data.detail
                })
                .finally(() => {
                    const voucher = voucherManager.getVoucher()
                    if (voucher && this.booking) {
                        var errorMessage = ''
                        this.discountVoucherCode = this.couponCode = voucher.code
                        this.applyCoupon()
                        $('.voucher-form input').attr('disabled', 'disabled')
                        $('.coupon-btn').attr('disabled', 'disabled')
                        $('.coupon-btn span').addClass('d-none')
                    }
                })
        },
        getAcceptedChallenge() {
            return api.get('/private/matches/accepted_challenges')
                .then(response => {
                    this.linkToAcceptedChallenge = true
                    this.acceptedChallenge = response.data[0];
                })
        },
        getChallengeTeams() {
            Promise.all([api.get('/private/teams'), api.get('/private/players/me')])
                .then(([teamsResponse, playerResponse]) => {
                    const player = playerResponse.data
                    this.challengeTeams = (teamsResponse.data || []).filter(team =>
                        team.owner_id === player.id || team.captain_id === player.id
                    )
                    if (this.challengeTeams.length === 1) {
                        this.challengeTeamId = this.challengeTeams[0].id
                    }
                })
                .catch(() => { this.challengeTeams = [] })
        },
        async getRefundVouchers() {
            return await api.get('/my/vouchers/refund/active')
                .then(response => {
                    this.refundVouchers = response.data.filter(voucher => voucher['amount'] <= this.booking['amount'] && voucher['amount'] >= this.booking.slot.facility.establishment.fee);
                })
        },
        async confirmAndPay() {
            if (this.openToChallenges && !this.challengeTeamId) {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'warning',
                    icon_color: 'text-warning',
                    title: 'Équipe requise',
                    detail: 'Sélectionnez l’équipe qui gérera les défis publics.'
                })
                return
            }
            // if (!this.user.delegation || this.user.delegation === '') {
            //     this.$store.dispatch('modal/triggerModal', {
            //         icon: 'warning',
            //         icon_color: 'text-warning',
            //         title: 'Informations manquantes',
            //         detail: 'Merci de sélectionner votre délégation.'
            //     })
            // } else {
            $('.booking-summary input').attr('disabled', 'disabled')
            $('.booking-summary button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            let data = {
                payment_method: this.paymentMethod,
                amountToPay: this.amountToPay,
                partsToPay: this.partsToPay,
                open_to_challenges: this.openToChallenges,
                challenge_team_id: this.challengeTeamId ?? null,
            }
            if (['online', 'cash'].includes(this.paymentMethod) && this.discountVoucherCode != '') {
                data['voucherCode'] = this.discountVoucherCode
            } else if (this.paymentMethod == 'refund voucher') {
                data['voucherCode'] = this.refundVoucherCode
            }
            if (this.linkToAcceptedChallenge && this.acceptedChallenge) {
                data['challenge_id'] = this.acceptedChallenge.id
            }
            data['delegation'] = this.user.delegation
            api.post('/booking/' + this.id + '/proceed', data)
                .then(response => {
                    const result = response.data
                    this.url = result.url
                    if (this.discountVoucherCode) {
                        // voucherManager.redeemVoucher(this.discountVoucherCode)
                    }
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'calendar_check',
                        icon_color: 'text-success',
                        title: 'Réservaion réussie',
                        detail: 'Votre réservation est maintenant en attente de confirmation. Vous recevrez une notification dès qu’elle sera validée.'
                    })
                    setTimeout(() => { window.location.replace(this.url) }, 3000);
                })
                .catch(error => {
                    this.error = error.response.data.detail
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Erreur',
                        detail: error.response.status >= 500 ? 'Une erreur est survenue! Veuillez réessayer plus tard.' : error.response.data.detail
                    })
                    $('.booking-summary input').removeAttr('disabled')
                    $('.booking-summary button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
            // }
        },
        applyCoupon() {
            var errorMessage = ''
            if (this.couponCode == '') {
                errorMessage = 'Veuillez renseigner le code'
            // } else if (!['online', 'cash'].includes(this.paymentMethod)) {
            //     errorMessage = 'Bon de réduction est éligible seulement pour le paiement en ligne'
            } else if (this.booking && this.booking.slot.sale_price > 0) {
                errorMessage = "Bon de réduction n'est pas éligible pour une réservation déjà en promo"
            }
            if (errorMessage) {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: errorMessage
                })
                return false
            }
            $('.coupon-btn').attr('disabled', 'disabled')
            $('.coupon-btn span').removeClass('d-none')
            api.post('/vouchers/apply/discount/' + this.couponCode, {booking_amount: this.booking.amount})
                .then(response => {
                    const result = response.data
                    this.couponFee = result.discount_amount
                    this.discountVoucherCode = this.couponCode
                    this.updateFees()
                })
                .catch(error => {
                    this.error = error.response.data.detail
                    this.couponFee = 0
                    this.discountVoucherCode = ''
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Erreur',
                        detail: (!this.error) ? 'Une erreur est survenue! Veuillez vérifier le code et réessayer.' : this.error
                    })
                    this.updateFees()
                })
            $('.coupon-btn').removeAttr('disabled')
            $('.coupon-btn span').addClass('d-none')
        },
        removeCoupon() {
            this.couponFee = 0
            this.couponCode = ''
            this.discountVoucherCode = ''
            this.updateFees()
        },
        formatDate(date, format = 'LL') {
            if (date) {
                date.replace('T', ' ').replace('.000000Z', '')
                return moment(String(date)).format(format)
            }
        },
        async updateOnlineFees() {
            this.getBooking()
        },
        updateFees() {
            if (this.booking) {
                this.bookingFee = this.booking.amount
                this.subTotal = this.bookingFee - parseFloat(this.couponFee)
                if (this.paymentMethod == 'cash') {
                    this.partsToPay = ""
                    this.amountToPay = this.remainingToPay = this.totalToPay = this.subTotal
                    this.transactionFee = this.remainingToRefund = 0
                } else if (this.paymentMethod == 'online') {
                    this.partsToPay = this.partsToPay ? this.partsToPay : "full"
                    this.partsToPay = this.partsToPay == "prepay" && this.subTotal <= this.defaultDepositPayment ? "full" : this.partsToPay
                    this.amountToPay = (this.partsToPay === "full") ? this.subTotal : this.defaultDepositPayment
                    this.remainingToPay = this.subTotal - this.amountToPay
                    this.remainingToRefund = 0
                    this.transactionFee = this.amountToPay * 0.016257143;
                    this.totalToPay = this.amountToPay + this.transactionFee
                } else if (this.paymentMethod == 'refund voucher') {
                    this.discountVoucherCode = this.couponCode = this.partsToPay = ""
                    this.refundVoucherCode = (!this.refundVoucherCode) ? this.refundVouchers[0].voucher_code : this.refundVoucherCode
                    this.refundVoucher = this.refundVouchers.filter((voucher) =>
                        voucher.voucher_code == this.refundVoucherCode
                    )[0]
                    this.subTotal = this.bookingFee
                    this.totalToPay = this.amountToPay = (this.refundVoucher.amount >= this.bookingFee) ? this.bookingFee : this.refundVoucher.amount
                    this.remainingToPay = this.subTotal - this.amountToPay
                    this.remainingToRefund = (this.refundVoucher.amount >= this.bookingFee) ? this.refundVoucher.amount - this.bookingFee : 0;
                    this.transactionFee = this.couponFee = 0
                }
            }
        }
    },
}
</script>
